import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { scrollYSlice } from '../../../store/scrollYSlice';
import { useScrollY } from '../../screen/useScrollY';
import { useAppDispatch } from '../useStore';

export const useStoreScrollY = () => {
  const { pathname } = useLocation();
  const { scrollY } = useScrollY();

  const dispatch = useAppDispatch();
  const scrollYActions = scrollYSlice.actions;

  useEffect(() => {
    if (pathname === pageInfo.homePage.path) {
      dispatch(scrollYActions.changeHomePageScrollY(scrollY));
    } else if (pathname === pageInfo.infoListPage.path) {
      dispatch(scrollYActions.changeInfoListPageScrollY(scrollY));
    } else if (pathname === pageInfo.productListPage.path) {
      dispatch(scrollYActions.changeProductListPageScrollY(scrollY));
    } else if (pathname === pageInfo.openMarketListPage.path) {
      dispatch(scrollYActions.changeOpenMarketListPageScrollY(scrollY));
    } else if (pathname === '/event-2024-02') {
      dispatch(scrollYActions.changeEvent202402ScrollY(scrollY));
    }
  }, [pathname, scrollY]);
};
